import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { useDisabledState } from '../../hooks/use-disabled-state';
import { calendarDayRecipe } from './styles/calendar-day.styles';
import type { CalendarDayPropsInterface } from './types/calendar-day.types';

export const CalendarDay = forwardRef<HTMLButtonElement, CalendarDayPropsInterface>(
  (props: CalendarDayPropsInterface, forwardedRef) => {
    const {
      children,
      className,
      css: cssProp,
      selected = false,
      today = false,
      disabled = false,
      ...rest
    } = props;

    const styles = css(calendarDayRecipe.raw({ selected, today, disabled }), cssProp);

    const a11yDisabledState = useDisabledState({ disabled, focusable: false });

    return (
      <button
        ref={forwardedRef}
        type="button"
        data-c11n-component="Calendar.Day"
        data-c11n-version={__C11N_VERSION__}
        aria-pressed={!!selected}
        aria-current={today ? 'date' : undefined}
        className={cx('c11n', styles, className)}
        {...rest}
        {...a11yDisabledState}
      >
        {children}
      </button>
    );
  },
);

CalendarDay.displayName = 'Calendar.Day';
